var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconProtractor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "\xEC\x84\xBC\xEC\x84\x9C/\xEA\xB0\x81\xEB\x8F\x84\xEA\xB8\xB0"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2020_15772",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2020_15772)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "square_foot",
    d: "M5.06968 17C4.49344 17 4.00444 16.7988 3.60266 16.3963C3.20089 15.9938 3 15.504 3 14.9268V3.91974C3 3.51673 3.17245 3.23826 3.51735 3.08432C3.86225 2.93057 4.16796 2.98708 4.43447 3.25387L6.05406 4.87651L5.20858 5.72344L5.72183 6.23756L6.56731 5.39036L8.90633 7.73338L8.06085 8.58058L8.57382 9.09471L9.41957 8.24751L11.8425 10.6749L10.9971 11.5218L11.5103 12.0359L12.3558 11.189L14.6948 13.532L13.8493 14.379L14.3626 14.8931L15.208 14.0462L16.7645 15.6053C17.0169 15.858 17.0664 16.1536 16.913 16.4922C16.7593 16.8307 16.4883 17 16.1 17H5.06968ZM5.27175 15.3987H13.6768L4.59854 6.30494V14.7244C4.59854 14.921 4.66161 15.0826 4.78776 15.2092C4.91409 15.3355 5.07542 15.3987 5.27175 15.3987Z",
    fill: "#161C24"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProtractor);
export default __webpack_public_path__ + "static/media/icon_protractor.d65769a0ccdd9a7445a9e8915c9a2579.svg";
export { ForwardRef as ReactComponent };